import { Box } from '@hivebrite/design-system/Box';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';
import { POSITIONS, Tooltip } from '@hivebrite/design-system/Tooltip';

import DisplayOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayOption';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { TextItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/textItemAttributes';

const Headline = ({
  item,
  onChange,
}: Omit<ComponentSettingsTab<TextItemAttributes>, 'defaultAttributes'>) => (
  <>
    <DisplayOption
      title={__('Display headline')}
      item={item}
      onChange={onChange}
    />
    <Box>
      <InputTitle boxProps={{ mb: 2, mr: 1 }} label={__('Headline')} />
      <Tooltip
        childrenElement={__(
          'Use %{First_Name} and %{Last_Name} to display users name',
        )}
        initialPosition={POSITIONS['BOTTOM-RIGHT']}
      >
        <FontAwesomeIcon
          iconName="circle-info"
          iconType={CATEGORIES.SOLID}
          color="primary"
          height="16px"
        />
      </Tooltip>
    </Box>
    <TextSetting
      item={item}
      maxLength={50}
      onChange={onChange}
      placeholder={__('Enter a headline')}
      settingKey="content"
      width="100%"
    />
  </>
);

export default Headline;
